module.exports = __webpack_public_path__ + "static/media/customer_point.5fe36f11.svg";